import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';

@Component({
  selector: 'app-plagiarism-checker',
  templateUrl: './plagiarism-checker.component.html',
  styleUrls: ['./plagiarism-checker.component.scss']
})
export class PlagiarismCheckerComponent implements OnInit {
  video_pause: boolean = false;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('抄襲檢查 | 領先的抄襲偵測 | Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: "超過 1,700 家國際出版機構信賴的抄襲檢查技術，精準比對、快速檢查。立即獲得免費抄襲檢查分數" });
    this.metaTagService.updateTag({ property: 'og:title', content: '抄襲檢查 | 領先的抄襲偵測 | Trinka AI' });
    this.metaTagService.updateTag({ property: 'og:description', content: '超過 1,700 家國際出版機構信賴的抄襲檢查技術，精準比對、快速檢查。立即獲得免費抄襲檢查分數' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/plagiarism-check' });
    
  }
  
  playPause() {
    var myVideo: any = document.getElementById("myVideo");
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
    this.video_pause= !this.video_pause;  
  }
  showTab = 1;
  advancePlagiarism(index: number) {
    this.showTab = index;
  }

  standardshowTab = 2;
  standardPlagiarism(index: number) {
    this.standardshowTab = index;
  }

  freeshowTab = 1;
  freeScore(index: number) {
    this.freeshowTab = index;
  }

}
